"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var companyTypesEnum;
(function (companyTypesEnum) {
    companyTypesEnum[companyTypesEnum["model"] = 0] = "model";
    companyTypesEnum[companyTypesEnum["partner"] = 1] = "partner";
    companyTypesEnum[companyTypesEnum["customer"] = 2] = "customer";
    companyTypesEnum[companyTypesEnum["billingIssue"] = 3] = "billingIssue";
    companyTypesEnum[companyTypesEnum["blocked"] = 4] = "blocked";
    companyTypesEnum[companyTypesEnum["billingBlocked"] = 5] = "billingBlocked";
    companyTypesEnum[companyTypesEnum["internalTest"] = 6] = "internalTest";
    companyTypesEnum[companyTypesEnum["newAccount"] = 7] = "newAccount";
    companyTypesEnum[companyTypesEnum["canceled"] = 8] = "canceled";
    companyTypesEnum[companyTypesEnum["trial"] = 9] = "trial";
})(companyTypesEnum || (companyTypesEnum = {}));
